export const socialNotifications = {
  socialNotifTitle: "Actividad",
  socialNotifMarkAll: "Marcar todo como leído",
  socialNotifEmpty: "Sin actividad aún",
  socialNotifEmptyDesc: "Cuando haya nueva actividad, la verás aquí",
  socialNotifJustNow: "Ahora",
  socialNotifMinAgo: "Hace {{count}}m",
  socialNotifHrsAgo: "Hace {{count}}h",
  socialNotifDaysAgo: "Hace {{count}}d",
  socialNotifWeeksAgo: "Hace {{count}}sem",
  socialNotifFollowers: "Seguidores",
  socialNotifPrizes: "Premios",
  socialNotifNewGames: "Juegos nuevos",
  socialNotifPromos: "Promos",
  socialNotifTournaments: "Torneos",
  socialNotifComments: "Comentarios",
};
